import React from 'react';

const FilesHeader: React.FC = React.memo(() => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Αρχεία</h1>
          <p className="mt-2 text-gray-600">Διαχειριστείτε τα έγγραφα και αρχεία σας</p>
        </div>
      </div>
    </div>
  );
});

FilesHeader.displayName = 'FilesHeader';

export default FilesHeader;
